import BaseWindow from "../core/views/BaseWindow";
import BaseView from "../core/views/BaseView";
import C_Layout from "../core/const/C_Layout";
import C_PointerEvt from "../core/const/C_PointerEvt";
import Button from "../core/ui/Button";
import C_GameEvent from "../core/const/C_GameEvent";

class PaytableWin extends BaseWindow
{
    constructor()
    {
        super();
        document.body.style.cursor = "url('styles/custom_cursor1.png') 5 5, auto";
        this.windowLayout = C_Layout.TAB;
        this.topPadding = 8;
        this.bottomPadding = 10;
        this.on(C_PointerEvt.MOVE, this.onMove, this);
        this.on(C_PointerEvt.DOWN, this.onPointerDown, this);
        this.on(C_PointerEvt.UP, this.onPointerUp, this);
        // this.create();
    }


    onMove(e)
    {
        e.stopPropagation();
    }


    onPointerDown(e)
    {
        this.startSwipeX = e.data.getLocalPosition(this).x;
    }

    onPointerUp(e)
    {
        if (e.target == this.leftArrow || e.target == this.rightArrow || e.target == this.closeBtn)
        {
            return;
        }
        this.endSwipeX = e.data.getLocalPosition(this).x;
        let deltaSwipeX = this.endSwipeX - this.startSwipeX;
        if (deltaSwipeX > this.layout.relWidth(2))
        {
            this.prevTab();
        }
        else if (deltaSwipeX < -this.layout.relWidth(2))
        {
            this.nextTab();
        }
    }


    create()
    {
        super.create();
        // this.init();
        // this.finishDrawing();
        // // this.drawAfterSizing();
    }


    drawTitle()
    {
        let title = this.assets.getTF("PAY TABLE", this.textSize*2);
        this.addChild(title);
        this.layout.verticalAlignTop(title, 4, this.winBg);
        this.layout.horizontalAlignCenter(title, 0, this.winBg);

        let titleLight = this.assets.getSprite("title_light");
        this.layout.propHeightScale(titleLight, 7);
        this.addChild(titleLight);
        titleLight.y = title.y + title.height - titleLight.height*.3;
        this.layout.horizontalAlignCenter(titleLight, 0, this.winBg)
    }


    drawContent()
    {
        this.textSize = this.layout.relHeight(3);
        this.gap = this.layout.relWidth(1);

        this.addPage1();
        this.addPage2();
        this.addPage3();
        this.addPage4();
        this.addPage5();
        this.addPage6();
        this.addPage7();
        this.addPage8();
        this.addPage9();
    }


    addPage1()
    {
        this.createRow();

        let tf1 = this.assets.getTF("SMART BULLETS:", this.textSize);
        this.currentRow.addChild(tf1);

        let tf2 = this.assets.getTF("Shoot at your enemies with TARGET SEEKING BULLETS!", this.textSize);
        this.currentRow.addChild(tf2);

        let imagesContainer = new PIXI.Container();
        this.currentRow.addChild(imagesContainer);

        let icon1 = this.assets.getSprite("shoot_img_0");
        this.layout.propHeightScale(icon1, 30);
        imagesContainer.addChild(icon1);

        let icon2 = this.assets.getSprite("shoot_img_1");
        this.layout.propHeightScale(icon2, 30);
        icon2.x = icon1.x + icon1.width + this.gap;
        imagesContainer.addChild(icon2);

        let icon3 = this.assets.getSprite("shoot_img_2");
        this.layout.propHeightScale(icon3, 30);
        icon3.x = icon2.x + icon2.width + this.gap;
        imagesContainer.addChild(icon3);

        let txtInfoContainer = new PIXI.Container();
        this.currentRow.addChild(txtInfoContainer);

        let icon1Desc = this.assets.getTF("These bloodthirsty bullets will never stray.", this.textSize, null,
            "#ffffff", null, icon1.width*.9);
        txtInfoContainer.addChild(icon1Desc);

        let icon2Desc = this.assets.getTF("They will always find a target!", this.textSize, null,
            "#ffffff", null, icon2.width*.9);
        txtInfoContainer.addChild(icon2Desc);

        let icon3Desc = this.assets.getTF("Is it the target you want?\nAim true and it will be.", this.textSize, null,
            "#ffffff", null, icon2.width*.9);
        txtInfoContainer.addChild(icon3Desc);

        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        tf2.x = rowCenter - tf2.width/2;
        this.layout.horizontalAlignCenter(icon1Desc, 0, icon1);
        this.layout.horizontalAlignCenter(icon2Desc, 0, icon2);
        this.layout.horizontalAlignCenter(icon3Desc, 0, icon3);

        // position vertical
        tf2.y = tf1.y + tf1.height;
        imagesContainer.y = tf2.y + tf2.height + this.gap;
        txtInfoContainer.y = imagesContainer.y + imagesContainer.height + this.gap;
    }


    addPage2()
    {
        this.createRow();

        let tf1 = this.assets.getTF("BET RANGES:", this.textSize);
        this.currentRow.addChild(tf1);

        let ship1Cont = new PIXI.Container();
        this.currentRow.addChild(ship1Cont);

        let ship1 = this.assets.getSprite("cockpit_1");
        this.layout.propHeightScale(ship1, 14);
        ship1Cont.addChild(ship1);
        ship1.x = ship1.width*.25;

        let ship1Name = this.assets.getTF("DEFENDERS", this.textSize);
        ship1Cont.addChild(ship1Name);
        ship1Name.x = (ship1.width*.25 - ship1Name.width)/2;

        let ship1Bet = this.assets.getTF("Bet range 1-9", this.textSize);
        ship1Cont.addChild(ship1Bet);
        ship1Bet.x = ship1.x + ship1.width + (ship1.width*.35 - ship1Bet.width)/2;


        let ship2Cont = new PIXI.Container();
        this.currentRow.addChild(ship2Cont);

        let ship2 = this.assets.getSprite("cockpit_2");
        this.layout.propHeightScale(ship2, 14);
        ship2Cont.addChild(ship2);
        ship2.x = ship2.width*.25;

        let ship2Name = this.assets.getTF("SLAYERS", this.textSize);
        ship2Cont.addChild(ship2Name);
        ship2Name.x = (ship2.width*.25 - ship2Name.width)/2;

        let ship2Bet = this.assets.getTF("Bet range 10-90", this.textSize);
        ship2Cont.addChild(ship2Bet);
        ship2Bet.x = ship2.x + ship2.width + (ship2.width*.35 - ship2Bet.width)/2;


        let ship3Cont = new PIXI.Container();
        this.currentRow.addChild(ship3Cont);

        let ship3 = this.assets.getSprite("cockpit_3");
        this.layout.propHeightScale(ship3, 14);
        ship3Cont.addChild(ship3);
        ship3.x = ship3.width*.25;

        let ship3Name = this.assets.getTF("BOOTLEGGERS", this.textSize);
        ship3Cont.addChild(ship3Name);
        ship3Name.x = (ship3.width*.25 - ship3Name.width)/2;

        let ship3Bet = this.assets.getTF("Bet range 100-1000", this.textSize);
        ship3Cont.addChild(ship3Bet);
        ship3Bet.x = ship3.x + ship3.width + (ship3.width*.35 - ship3Bet.width)/2;

        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        let highestWidth = ship1Cont.width > ship2Cont.width ?
            (ship1Cont.width > ship3Cont.width ? ship1Cont.width : ship3Cont.width) :
            (ship2Cont.width > ship3Cont.width ? ship2Cont.width : ship3Cont.width);
        ship1Cont.x = rowCenter - highestWidth/2;
        ship2Cont.x = rowCenter - highestWidth/2;
        ship3Cont.x = rowCenter - highestWidth/2;

        // position vertical
        ship1Name.y = (ship1Cont.height - ship1Name.height)/2;
        ship1Bet.y = ship1Name.y;
        ship1Cont.y = tf1.y + tf1.height + this.gap;
        ship2Name.y = (ship2Cont.height - ship2Name.height)/2;
        ship2Bet.y = ship2Name.y;
        ship2Cont.y = ship1Cont.y + ship1Cont.height + this.gap/2;
        ship3Name.y = (ship3Cont.height - ship3Name.height)/2;
        ship3Bet.y = ship3Name.y;
        ship3Cont.y = ship2Cont.y + ship2Cont.height + this.gap/2;
    }


    addPage3()
    {
        this.createRow();

        let tf1 = this.assets.getTF("DEBRIS:", this.textSize);
        this.currentRow.addChild(tf1);

        let tf2 = this.assets.getTF("Debris is a natural side effect of war. If allowed to float into space, it's also a very costly side effect. These parts are worth a small fortune, don't let them get away!",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(65));
        this.currentRow.addChild(tf2);

        let debrisContainer = new PIXI.Container();
        this.currentRow.addChild(debrisContainer);

        let debris1 = this.assets.getSprite("ship_12");
        this.layout.propHeightScale(debris1, 11);
        debrisContainer.addChild(debris1);

        let debris2 = this.assets.getSprite("ship_13");
        this.layout.propHeightScale(debris2, 11);
        debris2.x = debris1.x + debris1.width + this.gap*2;
        debrisContainer.addChild(debris2);

        let debris3 = this.assets.getSprite("ship_14");
        this.layout.propHeightScale(debris3, 12);
        debris3.x = debris2.x + debris2.width + this.gap*2;
        debrisContainer.addChild(debris3);

        let debris4 = this.assets.getSprite("ship_15");
        this.layout.propHeightScale(debris4, 13);
        debris4.x = debris3.x + debris3.width + this.gap*2;
        debrisContainer.addChild(debris4);

        let debris5 = this.assets.getSprite("ship_11");
        this.layout.propHeightScale(debris5, 14);
        debris5.x = debris4.x + debris4.width + this.gap*2;
        debrisContainer.addChild(debris5);

        let debris6 = this.assets.getSprite("ship_10");
        this.layout.propHeightScale(debris6, 16);
        debris6.x = debris5.x + debris5.width + this.gap*2;
        debrisContainer.addChild(debris6);

        let debPrizes = new PIXI.Container();
        this.currentRow.addChild(debPrizes);

        let debris1Prize = this.assets.getTF("x2", this.textSize);
        debPrizes.addChild(debris1Prize);
        let coin1 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin1, 3);
        coin1.x = debris1Prize.x + debris1Prize.width + this.gap/2;
        debris1Prize.addChild(coin1);

        let debris2Prize = this.assets.getTF("x2", this.textSize);
        debPrizes.addChild(debris2Prize);
        let coin2 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin2, 3);
        coin2.x = debris2Prize.x + debris2Prize.width + this.gap/2;
        debris2Prize.addChild(coin2);

        let debris3Prize = this.assets.getTF("x3", this.textSize);
        debPrizes.addChild(debris3Prize);
        let coin3 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin3, 3);
        coin3.x = debris3Prize.x + debris3Prize.width + this.gap/2;
        debris3Prize.addChild(coin3);

        let debris4Prize = this.assets.getTF("x4", this.textSize);
        debPrizes.addChild(debris4Prize);
        let coin4 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin4, 3);
        coin4.x = debris4Prize.x + debris4Prize.width + this.gap/2;
        debris4Prize.addChild(coin4);

        let debris5Prize = this.assets.getTF("x5", this.textSize);
        debPrizes.addChild(debris5Prize);
        let coin5 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin5, 3);
        coin5.x = debris5Prize.x + debris5Prize.width + this.gap/2;
        debris5Prize.addChild(coin5);

        let debris6Prize = this.assets.getTF("x6", this.textSize);
        debPrizes.addChild(debris6Prize);
        let coin6 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin6, 3);
        coin6.x = debris6Prize.x + debris6Prize.width + this.gap/2;
        debris6Prize.addChild(coin6);

        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        tf2.x = rowCenter - tf2.width/2;
        debrisContainer.x = rowCenter - debrisContainer.width/2;
        this.layout.horizontalAlignCenter(debris1Prize, 0, debris1);
        debris1Prize.x += debrisContainer.x;
        this.layout.horizontalAlignCenter(debris2Prize, 0, debris2);
        debris2Prize.x += debrisContainer.x;
        this.layout.horizontalAlignCenter(debris3Prize, 0, debris3);
        debris3Prize.x += debrisContainer.x;
        this.layout.horizontalAlignCenter(debris4Prize, 0, debris4);
        debris4Prize.x += debrisContainer.x;
        this.layout.horizontalAlignCenter(debris5Prize, 0, debris5);
        debris5Prize.x += debrisContainer.x;
        this.layout.horizontalAlignCenter(debris6Prize, 0, debris6);
        debris6Prize.x += debrisContainer.x;

        // position vertical
        tf2.y = tf1.y + tf1.height;
        debris1.y = debrisContainer.height - debris1.height;
        debris2.y = debrisContainer.height - debris2.height;
        debris3.y = debrisContainer.height - debris3.height;
        debris4.y = debrisContainer.height - debris4.height;
        debris5.y = debrisContainer.height - debris5.height;
        debrisContainer.y = tf2.y + tf2.height + this.gap*2;
        debPrizes.y = debrisContainer.y + debrisContainer.height + this.gap/2;
    }


    addPage4()
    {
        this.createRow();

        let tf1 = this.assets.getTF("SPACE ROCKS:", this.textSize);
        this.currentRow.addChild(tf1);

        let tf2 = this.assets.getTF("You never know when the next space rock will reach the Earth and cause a cataclysm. It's happened before! Better to be safe and shoot them, no? Doesn't hurt that these rocks are made of valuable treasure",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(65));
        this.currentRow.addChild(tf2);

        let rocksContainer = new PIXI.Container();
        this.currentRow.addChild(rocksContainer);

        let rock1 = this.assets.getSprite("ship_7");
        this.layout.propHeightScale(rock1, 13);
        rocksContainer.addChild(rock1);

        let rock2 = this.assets.getSprite("ship_6");
        this.layout.propHeightScale(rock2, 14);
        rock2.x = rock1.x + rock1.width + this.gap*3;
        rocksContainer.addChild(rock2);

        let rock3 = this.assets.getSprite("ship_9_over");
        this.layout.propHeightScale(rock3, 17);
        rock3.x = rock2.x + rock2.width + this.gap*3;
        rocksContainer.addChild(rock3);

        let rock4 = this.assets.getSprite("ship_8");
        this.layout.propHeightScale(rock4, 18);
        rock4.x = rock3.x + rock3.width + this.gap*3;
        rocksContainer.addChild(rock4);

        let rock5 = this.assets.getSprite("ship_5");
        this.layout.propHeightScale(rock5, 26);
        rock5.x = rock4.x + rock4.width + this.gap*3;
        rocksContainer.addChild(rock5);

        let rockPrizes = new PIXI.Container();
        this.currentRow.addChild(rockPrizes);

        let rock1Prize = this.assets.getTF("x7", this.textSize);
        rockPrizes.addChild(rock1Prize);
        let coin1 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin1, 3);
        coin1.x = rock1Prize.x + rock1Prize.width + this.gap/2;
        rock1Prize.addChild(coin1);

        let rock2Prize = this.assets.getTF("x8", this.textSize);
        rockPrizes.addChild(rock2Prize);
        let coin2 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin2, 3);
        coin2.x = rock2Prize.x + rock2Prize.width + this.gap/2;
        rock2Prize.addChild(coin2);

        let rock3Prize = this.assets.getTF("x10", this.textSize);
        rockPrizes.addChild(rock3Prize);
        let coin3 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin3, 3);
        coin3.x = rock3Prize.x + rock3Prize.width + this.gap/2;
        rock3Prize.addChild(coin3);

        let rock4Prize = this.assets.getTF("x12", this.textSize);
        rockPrizes.addChild(rock4Prize);
        let coin4 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin4, 3);
        coin4.x = rock4Prize.x + rock4Prize.width + this.gap/2;
        rock4Prize.addChild(coin4);

        let rock5Prize = this.assets.getTF("x15", this.textSize);
        rockPrizes.addChild(rock5Prize);
        let coin5 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin5, 3);
        coin5.x = rock5Prize.x + rock5Prize.width + this.gap/2;
        rock5Prize.addChild(coin5);

        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        tf2.x = rowCenter - tf2.width/2;
        rocksContainer.x = rowCenter - rocksContainer.width/2;
        this.layout.horizontalAlignCenter(rock1Prize, 0, rock1);
        rock1Prize.x += rocksContainer.x;
        this.layout.horizontalAlignCenter(rock2Prize, 0, rock2);
        rock2Prize.x += rocksContainer.x;
        this.layout.horizontalAlignCenter(rock3Prize, 0, rock3);
        rock3Prize.x += rocksContainer.x;
        this.layout.horizontalAlignCenter(rock4Prize, 0, rock4);
        rock4Prize.x += rocksContainer.x;
        this.layout.horizontalAlignCenter(rock5Prize, 0, rock5);
        rock5Prize.x += rocksContainer.x;

        // position vertical
        tf2.y = tf1.y + tf1.height;
        rock1.y = rocksContainer.height - rock1.height;
        rock2.y = rocksContainer.height - rock2.height;
        rock3.y = rocksContainer.height - rock3.height;
        rock4.y = rocksContainer.height - rock4.height;
        rocksContainer.y = tf2.y + tf2.height + this.gap;
        rockPrizes.y = rocksContainer.y + rocksContainer.height + this.gap/2;
    }


    addPage5()
    {
        this.createRow();

        let tf1 = this.assets.getTF("CRATES:", this.textSize);
        this.currentRow.addChild(tf1);

        let tf2 = this.assets.getTF("Someone thought it was valuable enough to lug around space, don't just let it get away!",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(65));
        this.currentRow.addChild(tf2);

        let cratesContainer = new PIXI.Container();
        this.currentRow.addChild(cratesContainer);

        let crate1 = this.assets.getSprite("ship_17");
        this.layout.propHeightScale(crate1, 12);
        cratesContainer.addChild(crate1);

        let crate2 = this.assets.getSprite("ship_18");
        this.layout.propHeightScale(crate2, 14);
        crate2.x = crate1.x + crate1.width + this.gap*3;
        cratesContainer.addChild(crate2);

        let crate3 = this.assets.getSprite("ship_19");
        this.layout.propHeightScale(crate3, 17);
        crate3.x = crate2.x + crate2.width + this.gap*3;
        cratesContainer.addChild(crate3);

        let crate4 = this.assets.getSprite("ship_20");
        this.layout.propHeightScale(crate4, 18);
        crate4.x = crate3.x + crate3.width + this.gap*3;
        cratesContainer.addChild(crate4);

        let cratePrizes = new PIXI.Container();
        this.currentRow.addChild(cratePrizes);

        let crate1Prize = this.assets.getTF("x10", this.textSize);
        cratePrizes.addChild(crate1Prize);
        let coin1 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin1, 3);
        coin1.x = crate1Prize.x + crate1Prize.width + this.gap/2;
        crate1Prize.addChild(coin1);

        let crate2Prize = this.assets.getTF("x15", this.textSize);
        cratePrizes.addChild(crate2Prize);
        let coin2 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin2, 3);
        coin2.x = crate2Prize.x + crate2Prize.width + this.gap/2;
        crate2Prize.addChild(coin2);

        let crate3Prize = this.assets.getTF("x20", this.textSize);
        cratePrizes.addChild(crate3Prize);
        let coin3 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin3, 3);
        coin3.x = crate3Prize.x + crate3Prize.width + this.gap/2;
        crate3Prize.addChild(coin3);

        let crate4Prize = this.assets.getTF("x25", this.textSize);
        cratePrizes.addChild(crate4Prize);
        let coin4 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin4, 3);
        coin4.x = crate4Prize.x + crate4Prize.width + this.gap/2;
        crate4Prize.addChild(coin4);


        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        tf2.x = rowCenter - tf2.width/2;
        cratesContainer.x = rowCenter - cratesContainer.width/2;
        this.layout.horizontalAlignCenter(crate1Prize, 0, crate1);
        crate1Prize.x += cratesContainer.x;
        this.layout.horizontalAlignCenter(crate2Prize, 0, crate2);
        crate2Prize.x += cratesContainer.x;
        this.layout.horizontalAlignCenter(crate3Prize, 0, crate3);
        crate3Prize.x += cratesContainer.x;
        this.layout.horizontalAlignCenter(crate4Prize, 0, crate4);
        crate4Prize.x += cratesContainer.x;

        // position vertical
        tf2.y = tf1.y + tf1.height;
        crate1.y = cratesContainer.height - crate1.height;
        crate2.y = cratesContainer.height - crate2.height;
        crate3.y = cratesContainer.height - crate3.height;
        crate4.y = cratesContainer.height - crate4.height;
        cratesContainer.y = tf2.y + tf2.height + this.gap*3;
        cratePrizes.y = cratesContainer.y + cratesContainer.height + this.gap/2;
    }


    addPage6()
    {
        this.createRow();

        let tf1 = this.assets.getTF("ENEMY SHIPS:", this.textSize);
        this.currentRow.addChild(tf1);

        let tf2 = this.assets.getTF("Your enemies don't like you that much, but don't worry, your shield will not fail you. Those ENEMY SHIPS can fire all they want, you will not suffer the consequences.",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(65));
        this.currentRow.addChild(tf2);

        let row1Ships = new PIXI.Container();
        this.currentRow.addChild(row1Ships);

        let ship1 = this.assets.getSprite("ship_1");
        this.layout.propHeightScale(ship1, 10);
        row1Ships.addChild(ship1);

        let ship2 = this.assets.getSprite("ship_2");
        this.layout.propHeightScale(ship2, 18);
        ship2.x = ship1.x + ship1.width + this.gap*4;
        row1Ships.addChild(ship2);

        let ship3 = this.assets.getSprite("ship_3");
        this.layout.propHeightScale(ship3, 16);
        ship3.x = ship2.x + ship2.width + this.gap*4;
        row1Ships.addChild(ship3);

        let shipPrizesContainer = new PIXI.Container();
        this.currentRow.addChild(shipPrizesContainer);

        let ship1Prize = this.assets.getTF("x20", this.textSize);
        shipPrizesContainer.addChild(ship1Prize);
        let coin1 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin1, 3);
        coin1.x = ship1Prize.x + ship1Prize.width + this.gap/2;
        ship1Prize.addChild(coin1);

        let ship2Prize = this.assets.getTF("x25", this.textSize);
        shipPrizesContainer.addChild(ship2Prize);
        let coin2 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin2, 3);
        coin2.x = ship2Prize.x + ship2Prize.width + this.gap/2;
        ship2Prize.addChild(coin2);

        let ship3Prize = this.assets.getTF("x30", this.textSize);
        shipPrizesContainer.addChild(ship3Prize);
        let coin3 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin3, 3);
        coin3.x = ship3Prize.x + ship3Prize.width + this.gap/2;
        ship3Prize.addChild(coin3);

        let ship4 = this.assets.getSprite("ship_4");
        this.layout.propHeightScale(ship4, 20);
        this.currentRow.addChild(ship4);

        let ship4Prize = this.assets.getTF("x40", this.textSize);
        this.currentRow.addChild(ship4Prize);
        let coin4 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin4, 3);
        coin4.x = ship4Prize.x + ship4Prize.width + this.gap/2;
        ship4Prize.addChild(coin4);


        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        tf2.x = rowCenter - tf2.width/2;
        row1Ships.x = rowCenter - row1Ships.width/2;
        this.layout.horizontalAlignCenter(ship1Prize, 0, ship1);
        ship1Prize.x += row1Ships.x;
        this.layout.horizontalAlignCenter(ship2Prize, 0, ship2);
        ship2Prize.x += row1Ships.x;
        this.layout.horizontalAlignCenter(ship3Prize, 0, ship3);
        ship3Prize.x += row1Ships.x;
        ship4.x = rowCenter - ship4.width/2;
        this.layout.horizontalAlignCenter(ship4Prize, 0, ship4);

        // position vertical
        tf2.y = tf1.y + tf1.height;
        ship1.y = (row1Ships.height - ship1.height)/2;
        row1Ships.y = tf2.y + tf2.height + this.gap;
        shipPrizesContainer.y = row1Ships.y + row1Ships.height*.9;
        ship4.y = shipPrizesContainer.y + shipPrizesContainer.height;
        ship4Prize.y = ship4.y + ship4.height;
    }


    addPage7()
    {
        this.createRow();

        let tf1 = this.assets.getTF("REFUGEE POD:", this.textSize);
        this.currentRow.addChild(tf1);

        let tf2 = this.assets.getTF("There's no knowing what made it out of a bad situation... Don't you just have to know what RANDOM PAYOUT comes from it, though?",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(65));
        this.currentRow.addChild(tf2);

        let pod = this.assets.getSprite("ship_21");
        this.layout.propHeightScale(pod, 25);
        this.currentRow.addChild(pod);

        let podPrize = this.assets.getTF("x40 ~ 80", this.textSize);
        this.currentRow.addChild(podPrize);
        let coin = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin, 3);
        coin.x = podPrize.x + podPrize.width + this.gap/2;
        podPrize.addChild(coin);

        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        tf2.x = rowCenter - tf2.width/2;
        pod.x = rowCenter - pod.width/2;
        this.layout.horizontalAlignCenter(podPrize, 0, pod);

        // position vertical
        tf2.y = tf1.y + tf1.height;
        pod.y = tf2.y + tf2.height + this.gap*3;
        podPrize.y = pod.y + pod.height + this.gap;
    }


    addPage8()
    {
        this.createRow();

        let tf1 = this.assets.getTF("FLARE:", this.textSize);
        this.currentRow.addChild(tf1);

        let tf2 = this.assets.getTF("When the flare appears, it means your allies are overwhelmed and seeking your aid! It just so happens that it pays to help your friends. Blast the flare to clear all objects on the screen, and receive your just reward, hero.",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(65));
        this.currentRow.addChild(tf2);

        let flare = this.assets.getSprite("ship_16");
        this.layout.propHeightScale(flare, 25);
        this.currentRow.addChild(flare);

        let flarePrize = this.assets.getTF("x60", this.textSize);
        this.currentRow.addChild(flarePrize);
        let coin = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin, 3);
        coin.x = flarePrize.x + flarePrize.width + this.gap/2;
        flarePrize.addChild(coin);

        // center horizontal
        let rowCenter = this.currentRow.width/2;
        tf1.x = rowCenter - tf1.width/2;
        tf2.x = rowCenter - tf2.width/2;
        flare.x = rowCenter - flare.width/2;
        this.layout.horizontalAlignCenter(flarePrize, 0, flare);
        // flarePrize.x += debrisContainer.x;

        // position vertical
        tf2.y = tf1.y + tf1.height;
        flare.y = tf2.y + tf2.height + this.gap*3;
        flarePrize.y = flare.y + flare.height + this.gap;
    }


    addPage9()
    {
        this.createRow();

        let nameCont = new PIXI.Container();
        this.currentRow.addChild(nameCont);

        let tf1 = this.assets.getTF("MOTHER OF MOONS: x80", this.textSize);
        nameCont.addChild(tf1);

        let coin = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin, 3);
        coin.x += tf1.x + tf1.width + this.gap/2;
        nameCont.addChild(coin);


        let descCont = new PIXI.Container();
        this.currentRow.addChild(descCont);

        let tf2 = this.assets.getTF("The Mother of Moons, the source of all non-star entities of the universe, is watching you shoot up her hard work, you ingrate!",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(20));
        descCont.addChild(tf2);

        let motm = this.assets.getSprite("motm_paytable");
        this.layout.propHeightScale(motm, 45);
        descCont.addChild(motm);
        motm.x = tf2.x + tf2.width;

        let tf3 = this.assets.getTF("That tends to make her angry. Lucky for you, you've got that super shield of yours. Ignore the moon bullets, go for the source. Bullets soothe that creature's temper.",
            this.textSize, null, "#ffffff", null, this.layout.relWidth(20));
        descCont.addChild(tf3);
        tf3.x = motm.x + motm.width;


        // center horizontal
        let rowCenter = this.currentRow.width/2;
        nameCont.x = rowCenter - nameCont.width/2;
        descCont.x = rowCenter - descCont.width/2;

        // position vertical
        tf2.y = (descCont.height - tf2.height)/2;
        tf3.y = (descCont.height - tf3.height)/2;
        descCont.y = nameCont.y + nameCont.height;

    }


    calculateBgSize()
    {
        super.calculateBgSize();
        // this.winBg = this.assets.getSprite("paytable_bg");
        // let bgAspectRatio = this.winBg.width/this.winBg.height;
        //
        // if (this.winBgWidth/this.winBgHeight > bgAspectRatio)
        // {
        //     this.winBg.width = this.winBgWidth;
        //     this.winBg.height = this.winBgWidth/bgAspectRatio;
        // }
        // else
        // {
        //     this.winBg.height = this.winBgHeight;
        //     this.winBg.width = this.winBgHeight*bgAspectRatio;
        // }
    }


    drawBackground()
    {
        this.addChildAt(this.winBg, this.getChildIndex(this.container));
        this.layout.horizontalAlignCenter(this.winBg, -50);
        this.layout.verticalAlignMiddle(this.winBg, -50);
    }


    drawAfterSizing()
    {
        // this.navBtnSize = 12;
        super.drawAfterSizing();
        this.drawTitle();
        this.drawArrows();
        this.drawNavInfo();
    }


    drawCloseBut()
    {
        this.closeBtn = new Button('back_button');
        this.layout.propHeightScale(this.closeBtn, this.navBtnSize, this.winBg);
        this.layout.horizontalAlignCenter(this.closeBtn, 0, this.winBg);
        this.layout.verticalAlignBottom(this.closeBtn, -5, this.winBg);
        this.addChild(this.closeBtn);
        this.closeBtn.on(C_PointerEvt.DOWN, this.close, this);

        let butText = this.assets.getTF("BACK TO GAME", this.layout.relHeight(40, this.closeBtn), null, "#00485d");
        this.layout.horizontalAlignCenter(butText, 0, this.closeBtn);
        this.layout.verticalAlignMiddle(butText, 0, this.closeBtn);
        this.addChild(butText);
        // butText.interactive = false;
    }


    drawArrows()
    {
        this.leftArrow = new Button('left_button');
        this.layout.propHeightScale(this.leftArrow, this.navBtnSize, this.winBg);
        this.layout.verticalAlignBottom(this.leftArrow, -5, this.winBg);
        this.leftArrow.x = this.closeBtn.x - this.leftArrow.width + this.closeBtn.width*.05;
        this.addChild(this.leftArrow);

        this.rightArrow = new Button('right_button');
        this.layout.propHeightScale(this.rightArrow, this.navBtnSize, this.winBg);
        this.layout.verticalAlignBottom(this.rightArrow, -5, this.winBg);
        this.rightArrow.x = this.closeBtn.x + this.closeBtn.width - this.closeBtn.width*.07;
        this.addChild(this.rightArrow);

        this.leftArrow.on(C_PointerEvt.DOWN, this.prevTab.bind(this));
        this.rightArrow.on(C_PointerEvt.DOWN, this.nextTab.bind(this));
    }


    prevTab()
    {
        this.navInfoCont.getChildAt(this.currentTabIdx).texture = this.assets.getTexture("page_index");
        super.prevTab();
        this.navInfoCont.getChildAt(this.currentTabIdx).texture = this.assets.getTexture("current_page_index");
    }


    nextTab()
    {
        this.navInfoCont.getChildAt(this.currentTabIdx).texture = this.assets.getTexture("page_index");
        super.nextTab();
        this.navInfoCont.getChildAt(this.currentTabIdx).texture = this.assets.getTexture("current_page_index");
    }


    drawNavInfo()
    {
        this.navInfoCont = new PIXI.Container();
        this.addChild(this.navInfoCont);

        for (let i = 0; i < this.rows.length; i++)
        {
            let ind = (i != this.currentTabIdx) ? this.assets.getSprite("page_index") : this.assets.getSprite("current_page_index");
            this.layout.propHeightScale(ind, 3, this.winBg);
            this.navInfoCont.addChild(ind);
            ind.x += (ind.width + this.gap)*i;
        }

        this.layout.horizontalAlignCenter(this.navInfoCont, 0, this.winBg);
        this.layout.verticalAlignBottom(this.navInfoCont, 13, this.winBg);
    }


    close()
    {
        super.close();

        TweenMax.delayedCall(0.3, this.postRemove, null, this);
    }


    postRemove()
    {
        this.dispatcher.emit(C_GameEvent.POPUP_CLOSED);

        // document.body.style.cursor = "none";
        // this.app.assets.removeDynamic();
        // this.app.model.unpause();
    }

}

export default PaytableWin;